// 服务端需要用到的组件，可以在这里做export

"use client";

export { Swiper, Button, Rate } from 'react-vant';

export { Arrow, Success } from '@react-vant/icons';